import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { Mail, Phone, MapPin } from "lucide-react";
import { Section } from "@/components/site/Section";
import { contact, stores, whatsappLink } from "@/content/site";

export const Route = createFileRoute("/contato/")({
  head: () => ({
    meta: [
      { title: "Fale com a Contato Internet — Atendimento e cobertura" },
      {
        name: "description",
        content:
          "Fale com a Contato Internet por WhatsApp, telefone ou e-mail e verifique a cobertura de fibra óptica na sua região.",
      },
      { property: "og:title", content: "Fale com a Contato Internet" },
      {
        property: "og:description",
        content: "WhatsApp, telefone, e-mail e consulta de cobertura de fibra óptica.",
      },
    ],
  }),
  component: ContatoPage,
});

function ContatoPage() {
  const [form, setForm] = useState({ nome: "", cidade: "", mensagem: "" });

  const message = `Olá! Meu nome é ${form.nome || "(nome)"}, sou de ${
    form.cidade || "(cidade)"
  }. ${form.mensagem || "Gostaria de mais informações sobre os planos."}`;

  return (
    <>
      <Section
        reveal
        eyebrow="Atendimento"
        title="Fale com a gente"
        text="Preencha os campos e continue a conversa direto no WhatsApp com um atendente."
      >
        <div className="grid gap-8 lg:grid-cols-[1.1fr_0.9fr]">
          <form
            className="rounded-3xl border border-border bg-card p-8"
            onSubmit={(e) => {
              e.preventDefault();
              window.open(whatsappLink(message), "_blank", "noreferrer");
            }}
          >
            <div className="grid gap-5">
              <label className="grid gap-2 text-sm font-bold">
                Nome
                <input
                  required
                  maxLength={80}
                  value={form.nome}
                  onChange={(e) => setForm({ ...form, nome: e.target.value })}
                  className="rounded-xl border border-input bg-background px-4 py-3 text-sm font-medium outline-none focus:border-primary"
                  placeholder="Seu nome completo"
                />
              </label>
              <label className="grid gap-2 text-sm font-bold">
                Cidade / bairro
                <input
                  required
                  maxLength={80}
                  value={form.cidade}
                  onChange={(e) => setForm({ ...form, cidade: e.target.value })}
                  className="rounded-xl border border-input bg-background px-4 py-3 text-sm font-medium outline-none focus:border-primary"
                  placeholder="Onde você quer instalar?"
                />
              </label>
              <label className="grid gap-2 text-sm font-bold">
                Mensagem
                <textarea
                  rows={4}
                  maxLength={600}
                  value={form.mensagem}
                  onChange={(e) => setForm({ ...form, mensagem: e.target.value })}
                  className="rounded-xl border border-input bg-background px-4 py-3 text-sm font-medium outline-none focus:border-primary"
                  placeholder="Como podemos ajudar?"
                />
              </label>
              <button
                type="submit"
                className="rounded-full bg-brand-yellow px-8 py-3.5 text-sm font-extrabold uppercase tracking-wide text-brand-yellow-foreground transition-transform hover:-translate-y-0.5"
              >
                Enviar pelo WhatsApp
              </button>
            </div>
          </form>

          <div className="grid content-start gap-4">
            <a
              href={`tel:+${contact.whatsapp}`}
              className="flex items-start gap-4 rounded-3xl border border-border bg-card p-6 transition-colors hover:border-primary/40"
            >
              <Phone className="mt-1 size-5 text-primary" />
              <span>
                <span className="block font-extrabold">Telefone</span>
                <span className="text-sm text-muted-foreground">{contact.phoneDisplay}</span>
              </span>
            </a>
            <a
              href={`mailto:${contact.email}`}
              className="flex items-start gap-4 rounded-3xl border border-border bg-card p-6 transition-colors hover:border-primary/40"
            >
              <Mail className="mt-1 size-5 text-primary" />
              <span>
                <span className="block font-extrabold">E-mail</span>
                <span className="text-sm text-muted-foreground">{contact.email}</span>
              </span>
            </a>
            {stores.map((s) => (
              <div
                key={s.city}
                className="flex items-start gap-4 rounded-3xl border border-border bg-card p-6"
              >
                <MapPin className="mt-1 size-5 text-primary" />
                <span>
                  <span className="block font-extrabold">{s.city}</span>
                  <span className="text-sm text-muted-foreground">{s.address}</span>
                </span>
              </div>
            ))}
          </div>
        </div>
      </Section>
    </>
  );
}
